<template>
    <div>
        <v-progress-circular
            v-if="isLoading"
            class="progress-spinner"
            :size="40"
            indeterminate
            color="primary" />
        <v-file-input
            v-else
            dark
            class="file-input"
            prepend-icon="mdi-plus"
            hide-input
            @change="addFile" />
    </div>
</template>

<script>
import { uploadFile } from '@/services/fileService';
export default{
    props: {
        scope: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            isLoading: false
        }
    },

    methods: {
        async addFile(file) {
            this.isLoading = true;
            if(!file) {
                return;
            }

            let response = await uploadFile(file)
            this.$emit('input', response);
            this.isLoading = false;
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/styles/theme.scss";

.file-input {
    background-color: $color-primary;
    border: 0.0625rem solid $color-grey-dark;
    border-radius: 0.25rem;
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
    padding-left: 0.875rem;
    padding-right: 0.375rem;
}

.progress-spinner{
    position: absolute;
    top: calc(50% - 1.25rem);
    left: calc(50% - 1.25rem);
}
</style>
